import { getServerSidePropsErrorHandler } from '@/utils/nextUtils/nextErrorHandlers'
import { loadTranslations } from '@/utils/translate/translate-server'
import {
  getExpressCheckoutPageProps,
  ExpressCheckoutPageProps,
  ExpressCheckoutPage,
} from '@/views/ExpressCheckoutView/pageProps.server'

export const getServerSideProps = getServerSidePropsErrorHandler<ExpressCheckoutPageProps>(
  async ({ federationClient, locale, next404, params, query, req, res }) => {
    const translations = await loadTranslations(locale, ['common', 'pif', 'account', 'app-promo'])
    return getExpressCheckoutPageProps({ params, query, locale, federationClient, req, res, next404, translations })
  },
)

export default ExpressCheckoutPage
